<template>
  <div>
    <div class="row">
      <div class="col">
        <div class="compact-container pl-3">
          <a
            aria-controls="collapseHelp"
            aria-expanded="false"
            class="cursor-pointer mr-2 help-container"
            data-target="#collapseHelp"
            data-toggle="collapse"
            role="button"
          >
            <section-title
              container-class="section-container"
              icon="far fa-question-circle"
              title="Ayuda"
              title-class="help-container-title"
            />
          </a>
          <a>
            <section-title
              container-class="section-container-solid"
              icon="fas fa-book"
              title=""
            />
          </a>
          <a class="ml-n5">
            <section-title
              container-class="section-container-solid"
              icon="fas fa-video"
              title=""
            />
          </a>
        </div>
      </div>
    </div>
    <div id="collapseHelp" class="collapse compact-body ml-n1">
      <a class="dropdown-item support-table shadow-top pb-n3 pt-2">
        <div class="div-help">
          <strong>Mesa de Apoyo</strong>
        </div>
      </a>
      <a class="d-flex align-items-center support-information" href="#">
        <div class="help-information mt-n4">
          <i class="fas fa-phone-square-alt" />
        </div>
        <div class="support-label">
          <span>787-773-6147</span>
        </div>
      </a>
      <a
        class="d-flex align-items-center support-information email-field"
        href="mailto:apoyoconversion@de.pr.gov"
      >
        <div class="help-information mt-n4">
          <i class="fas fa-envelope" />
        </div>
        <div class="support-label">
          <span class="text-decoration-underline">
            <u>apoyoconversion@de.pr.gov</u>
          </span>
        </div>
      </a>
    </div>
  </div>
</template>

<script>
import SectionTitle from '@/components/common/page/SectionTitle';
export default {
  name: 'CompactHeaderMenu',
  components: {
    SectionTitle,
  },
};
</script>

<style scoped>
.compact-container {
  padding: 10px 10px 0px 10px;
  display: flex;
  flex-direction: row;
  background: #2db782;
  height: 67px;
}

.compact-container >>> .section-container {
  display: flex;
  flex-direction: row;
  height: 45px !important;
}
.compact-container >>> .tag-badge-info {
  background: #fff !important;
}

.compact-container >>> .section-container .tag-badge-title-info {
  width: 40% !important;
}
.compact-container >>> .section-container .dot {
  border: none;
  margin-right: -15px;
  box-shadow: none;
  margin-top: 3px;
}
.compact-container >>> .section-container .dot > .title-icon {
  font-size: 22px !important;
}

.compact-container >>> .section-container-solid {
  background: transparent !important;
  margin-top: -5px !important;
}
.compact-container >>> .section-container-solid .dot {
  width: 40px !important;
  height: 40px !important;
  background: #2db782;
  border: 1px solid #fff;
}
.compact-container >>> .section-container-solid .dot > .title-icon {
  margin-top: 12px;
  color: #fff;
}

.compact-container >>> .dot {
  background: #fff;
  border: 1px solid #2db782;
  margin-left: 10px;
  margin-top: 6px;
}
.compact-container >>> .title-icon {
  color: #2db782;
  margin-top: 8px;
}

.compact-body {
  background: #ebebeb;
  max-height: 100px;
}

.compact-body .div-help {
  color: #3f5b60;
}
.compact-body .help-text {
  margin-left: -10px;
}
.compact-body .help-information {
  margin-left: -10px !important;
}
.compact-body .information-text {
  margin-left: -7px;
  font-family: 'Lato', sans-serif;
  font-size: 12px;
}
.compact-body .support-table {
  background: #f2f2f2 0% 0% no-repeat padding-box;
  opacity: 1;
}
.compact-body .support-information {
  text-align: left;
  font: Bold 16px/22px Lato;
  letter-spacing: 0;
  color: #20a874 !important;
  opacity: 1;
  height: auto;
  margin-left: 36px;
}
.compact-body .support-label {
  margin-left: -6px !important;
  text-decoration: underline;
  font-family: 'Lato', sans-serif;
  font-size: 15px;
}
.compact-body .shadow-top {
  -moz-box-shadow: inset 0 10px 10px -10px grey;
  -webkit-box-shadow: inset 0 10px 10px -10px grey;
  box-shadow: inset 0 10px 10px -10px grey;
}
.compact-body .dropdown-menu-custom {
  top: 95% !important;
}
.compact-body .dropdown-item {
  background: transparent;
}
.compact-body .dropdown-item:hover {
  background: none;
}
.compact-body .email-field {
  margin-top: -25px;
  padding-bottom: 40px;
}

.email-field {
  margin-top: -33px !important;
}
.help-container {
  width: 96px;
}
.compact-container >>> .help-container-title {
  margin-top: 11px !important;
  font-style: normal !important;
  font-size: 14px !important;
  color: #3f5b60;
}
</style>
